import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconZoneBlueSizeS from './IconZoneBlue_size_s';

const props: CreateIconArguments = {
  l: IconZoneBlueSizeS,
  m: IconZoneBlueSizeS,
  s: IconZoneBlueSizeS,
  xs: IconZoneBlueSizeS,
  name: 'IconZoneBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
